import { Button, Card, Form, Spin } from 'antd';
import React from "react";
import { getFormFieldByType, sanitizeFieldName } from "../../util/methods";
import SubListPageSetting from "../../components/SubList/subListPageSetting";

class SettingForm extends React.Component {

    componentDidMount() {
        const { fetch, page, getPageFilterData } = this.props;
        if (fetch && page) {
            if (getPageFilterData)
                getPageFilterData(page)
            fetch(page)
        }
    }

    handleSubmit = (e) => {
        // const {match} = this.props;
        e.preventDefault();
        // console.log('submitting ....')
        this.props.form.validateFields((err, values) => {
            if (err) {
                return console.log(err);
            }
            // console.log(values);
            const { _id } = this.props.data || {};
            if (_id) {
                this.props.onSubmit(values, _id, true);
            }
        });
    };

    pageChangeHandle = (e) => {
        console.log(e)
        const { getPageFilterData } = this.props;
        if (e && getPageFilterData) {
            getPageFilterData(e);
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { data, loading, filters, title, resource, form, pageData } = this.props;
        // console.log(data)
        // console.log(pageData)
        // console.log(pageData)
        const pageSelectableData = [];
        pageData && Object.keys(pageData).forEach(key => {
            const val = pageData[key];
            if (key !== '_id' && val && !val.required && val.options && !val.options.hidden && !val.options.notVisible) {
                // console.log(key, pageData[key]);
                pageSelectableData.push({ _id: key, name: key });
            }
        });
        // console.log(resource, data,filters)

        return (
            <Spin spinning={loading}>
                <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
                    <Form onSubmit={this.handleSubmit} layout="vertical">

                        {filters && Object.keys(filters).map((item, idx) => {
                            if (filters[item].type === 'Array' && filters[item].schema) {
                                return <SubListPageSetting key={item} item={filters[item]} form={form} data={data[item]}
                                    title={title}
                                    // pindex={idx}
                                    resource={resource} selectData={pageSelectableData} pageData={pageData}
                                    isFromSetting={true} />
                            } else {
                                return getFormFieldByType(filters, item, getFieldDecorator, data, {
                                    title: 'EDIT',
                                    isFromSetting: true,
                                    resource,
                                    onChange: this.pageChangeHandle
                                })
                            }
                        })}

                        <Form.Item>
                            <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Spin>
        );
    }
}

const CreateForm = Form.create({
    name: 'global_state',
})(SettingForm);

export default CreateForm;
